import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { InspectionReport } from "../../_objects/inspection-report";

@Injectable({
  providedIn: "root"
})
export class InspectionReportStateService {
  private inspectionReportSubject$ = new BehaviorSubject<InspectionReport | null>(null);
  public inspectionReport$: Observable<InspectionReport | null> = this.inspectionReportSubject$.asObservable();

  public getInspectionReport(): Observable<InspectionReport | null> {
    return this.inspectionReport$;
  }

  public setInspectionReport(inspectionReport: InspectionReport): void {
    this.inspectionReportSubject$.next(inspectionReport);
  }
}
